import { Button } from "@mui/material";
import { FormProvider, useFormContext } from "react-hook-form";
import { TypeForm } from "./TypeForm";
import "./custom-fields.scss";

// const specifications = [
//     {
//         id: 'string',
//         code: "Notebooks*Type",
//         name: "Общие",
//         position: 1,
//         features: [
//             {
//                 code: "Notebooks*Type*OperatingSystem",
//                 name: "Операционная система",
//                 description: "Операционная система",
//                 type: "ENUM",
//                 values: [
//                     {
//                         value: "Mac OS"
//                     },
//                     {
//                         value: "Windows"
//                     }
//                 ],
//                 mandatory: true,
//                 position: 1,
//             },
//             {
//                 code: "Notebooks*Type*Support3D",
//                 name: "Поддержка 3D",
//                 type: "BOOLEAN",
//                 mandatory: false,
//                 position: 2,
//             },
//             // STRING   
//             {
//                 code: "Notebooks*Type*Processor",
//                 name: "Процессор",
//                 type: "STRING",
//                 mandatory: false,
//                 position: 3,
//             },
//         ]
//     }
// ]

export const CustomFields = ({ specifications }) => {
    // доступ к родительскому useForm
    const { register, setValue, getValues } = useFormContext({
        defaultValues: {
            specifications: specifications || []
        }
    });

    /*
        Добавляем новый тип
    */
    const addNewType = () => {
        setValue(`specifications[${getValues('specifications').length}]`, {
            name: "",
            code: "",
            description: "",
            features: []
        })
    }

    return (
        <fieldset style={{ border: "none" }}>
            <div>
                {getValues('specifications').map((specification, index) => {
                    return <TypeForm
                        specification={specification}
                        index={index}
                    />
                })}
            </div>
            <Button onClick={addNewType} variant="outlined">Добавить новый раздел</Button>
        </fieldset>
    )
}